import styled from 'styled-components';
import DisplayTextBlock from '@carvana/showroom-content/TextBlock/Display';

import { Section, InnerSection } from '../../../../styles/section/section';

export const StyledSection = styled(Section)`
  padding-top: 35px;
  min-height: auto;
`;

export const StyledSectionInner = styled(InnerSection)`
  padding-top: 0;
  padding-bottom: 2.5rem;
`;

export const StyledFormWrapper = styled.div`
  max-width: 500px;
`;

export const StyledTextBlock = styled(DisplayTextBlock)`
  margin-bottom: 1rem;
  text-align: left;
  &.is-responsive ${DisplayTextBlock.SmallTitle} {
    font-size: 28px;
  }
`;

export const StyledText = styled(DisplayTextBlock.SmallTitle)``;
